export default __webpack_public_path__ + "static/media/suspicious-activity.b17d883b.svg";